import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Fab } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './Header';
import Footer from './Footer';
import CopyRights from './CopyRights';
const Layout: React.FC = () => {
	const [isVisible, setIsVisible] = useState(false);
	const toggleVisibility = () => {
		if (window.pageYOffset > 20) {
			setIsVisible(true);
		} else {
			setIsVisible(false);
		}
	};
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	};

	useEffect(() => {
		window.addEventListener('scroll', toggleVisibility);
		return () => {
			window.removeEventListener('scroll', toggleVisibility);
		};
	}, []);

	return (
		<>
			<Header />
			{/* <ReactConfetti height={height} recycle={false} /> */}
			<div className="content">{/* Your content goes here */}</div>
			{isVisible && (
				<Fab
					// className={isVisible ? 'box-shadow-show' : ''}
					color="primary"
					size="small"
					aria-label="scroll back to top"
					onClick={scrollToTop}
					style={{ position: 'fixed', bottom: '20px', right: '20px' }}
				>
					<KeyboardArrowUpIcon />
				</Fab>
			)}

			<div style={{ marginTop: '90px' }}>
				<ToastContainer position="top-right" autoClose={3000} />

				<Outlet />
			</div>
			{/* <Box sx={{ marginTop: { xs: '60px', lg: '90px' } }}>
				<ToastContainer position="top-right" autoClose={3000} />

				<Outlet />
			</Box> */}

			<Footer />
			<CopyRights />
			<div className="sidebar-content-div hd-btn">
				<div className="icon-sty">
					<a
						href="https://wa.me/919500066066?text=Hi%2C%20I%20saw%20your%20website%20%28CHAKARAVARTHY%20CATERING%20CENTER%20%29%2C%20I%20would%20like%20to%20know%20more%20information%20about%20your%20service."
						className="sidebar-icon"
						target="_blank"
						rel="noopener"
					>
						<svg
							width="33.163"
							height="33.158"
							viewBox="0 0 33.163 33.158"
							style={{ marginLeft: '6px', marginRight: '6px' }}
						>
							<ellipse
								id="Ellipse_25"
								data-name="Ellipse 25"
								cx="12.5"
								cy="12"
								rx="12.5"
								ry="12"
								transform="translate(4 4.579)"
								fill="#fff"
							/>
							<g id="Layer_2" data-name="Layer 2">
								<g id="Color">
									<g id="_08.Whatsapp" data-name="08.Whatsapp">
										<path
											id="Icon"
											d="M52.588,36A16.579,16.579,0,0,0,39.163,62.3l-2.072,6.159,6.379-2.039A16.579,16.579,0,1,0,52.588,36ZM61.4,59.447l-1.766,1.766c-1.857,1.857-6.781-.187-11.145-4.559s-6.321-9.284-4.555-11.12L45.7,43.767a1.853,1.853,0,0,1,2.508,0l2.6,2.595a1.728,1.728,0,0,1-.651,2.876,1.687,1.687,0,0,0-1.115,2.048,8.019,8.019,0,0,0,4.833,4.829A1.77,1.77,0,0,0,55.9,54.987a1.733,1.733,0,0,1,2.9-.651l2.6,2.6a1.853,1.853,0,0,1,0,2.508Z"
											transform="translate(-36.015 -36)"
											fill="#07d97e"
										/>
									</g>
								</g>
							</g>
						</svg>
					</a>
					{/* <img
						src="/assets/iso-certified.svg"
						alt="iso-certified"
						style={{ width: '80px', height: 'auto' }}
					/> */}
				</div>
			</div>
			<div className="sidebar-content-div2 hd-btn2" style={{ marginTop: '12px' }}>
				<div className="icon-sty">
					{/* <a
						href="https://wa.me/9500066066"
						className="sidebar-icon"
						target="_blank"
						rel="noopener"
					>
						<svg
							width="33.163"
							height="33.158"
							viewBox="0 0 33.163 33.158"
							style={{ marginLeft: '6px', marginRight: '6px' }}
						>
							<ellipse
								id="Ellipse_25"
								data-name="Ellipse 25"
								cx="12.5"
								cy="12"
								rx="12.5"
								ry="12"
								transform="translate(4 4.579)"
								fill="#fff"
							/>
							<g id="Layer_2" data-name="Layer 2">
								<g id="Color">
									<g id="_08.Whatsapp" data-name="08.Whatsapp">
										<path
											id="Icon"
											d="M52.588,36A16.579,16.579,0,0,0,39.163,62.3l-2.072,6.159,6.379-2.039A16.579,16.579,0,1,0,52.588,36ZM61.4,59.447l-1.766,1.766c-1.857,1.857-6.781-.187-11.145-4.559s-6.321-9.284-4.555-11.12L45.7,43.767a1.853,1.853,0,0,1,2.508,0l2.6,2.595a1.728,1.728,0,0,1-.651,2.876,1.687,1.687,0,0,0-1.115,2.048,8.019,8.019,0,0,0,4.833,4.829A1.77,1.77,0,0,0,55.9,54.987a1.733,1.733,0,0,1,2.9-.651l2.6,2.6a1.853,1.853,0,0,1,0,2.508Z"
											transform="translate(-36.015 -36)"
											fill="#07d97e"
										/>
									</g>
								</g>
							</g>
						</svg>
					</a> */}
					<img
						src="/events/ISO9001-2015 1.jpg"
						alt="iso-certified"
						style={{ width: '80px', height: 'auto' }}
					/>
				</div>
			</div>
			{/* <div className="sidebar-content-div2 hd-btn2"> */}
			{/* <div className="icon-sty2">
				<img
					src="/assets/iso-certified.svg"
					alt="iso-certified"
					style={{ width: '80px', height: 'auto' }}
				/>
			</div> */}
			{/* </div> */}
		</>
	);
};

export default Layout;
